import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Deep-Link-Ziel: liest `?<param>=<id>` und scrollt, sobald `ready` gilt,
 * zum Element mit `data-focus-id="<id>"` und hebt es kurz hervor.
 * Gibt die id zurueck, damit die Seite den Eintrag auch selbst markieren
 * oder aufklappen kann.
 */
export function useFocusParam(param: string, ready: boolean): string | null {
  const [params] = useSearchParams();
  const id = params.get(param);

  useEffect(() => {
    if (!id || !ready) return undefined;
    // Erst nach dem Rendern der Liste suchen.
    const t = window.setTimeout(() => focusElement(id), 50);
    return () => window.clearTimeout(t);
  }, [id, ready]);

  return id;
}

/** Scrollt zu `[data-focus-id="<id>"]` und hebt das Element kurz hervor. */
export function focusElement(id: string): boolean {
  // Attributwert in Anfuehrungszeichen; nur " und \ muessen maskiert werden
  // (CSS.escape fehlt in jsdom).
  const el = document.querySelector<HTMLElement>(`[data-focus-id="${id.replace(/["\\]/g, '\\$&')}"]`);
  if (!el) return false;
  if (typeof el.scrollIntoView === 'function') el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  el.classList.remove('ui-focus-flash');
  // Reflow, damit die Animation bei erneutem Sprung wieder anlaeuft.
  void el.offsetWidth;
  el.classList.add('ui-focus-flash');
  window.setTimeout(() => el.classList.remove('ui-focus-flash'), 2400);
  return true;
}
